import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

Vue.use(Vuex);

const ls = new SecureLS();

interface SpotifyCredentials {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
}

interface SpotifyRefreshTokenCredentials {
    accessToken: string;
    expiresIn: number;
}

export default new Vuex.Store({
    state: {
        accessToken: "",
        refreshToken: "",
        expiresIn: null as number | null,
        expirationStart: null as number | null,
    },
    mutations: {
        setAccessToken(state, accessToken: string) {
            state.accessToken = accessToken;
        },
        setRefreshToken(state, refreshToken: string) {
            state.refreshToken = refreshToken;
        },
        setExpiresIn(state, expiresIn: number) {
            state.expiresIn = expiresIn;
        },
        setExpirationStart(state, expirationStart: number) {
            state.expirationStart = expirationStart;
        },
    },
    actions: {
        setSpotifyCredentials({ commit }, credentials: SpotifyCredentials) {
            commit("setAccessToken", credentials.accessToken);
            commit("setRefreshToken", credentials.refreshToken);
            commit("setExpiresIn", credentials.expiresIn);
            commit("setExpirationStart", new Date().getTime());
        },
        updateSpotifyTokens({ commit }, token: SpotifyRefreshTokenCredentials) {
            commit("setAccessToken", token.accessToken);
            commit("setExpiresIn", token.expiresIn);
            commit("setExpirationStart", new Date().getTime());
        },
        clearSpotifyCredentials({ commit }) {
            commit("setAccessToken", "");
            commit("setRefreshToken", "");
            commit("setExpiresIn", null);
            commit("setExpirationStart", null);
        },
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key: string) => ls.get(key),
                setItem: (key: string, value: string) => ls.set(key, value),
                removeItem: (key: string) => ls.remove(key),
            },
        }),
    ],
});
